import { downloadFile } from '@/utils';

export const STUDENT_TEMPLATE_HEADERS = [
  'name',
  'student_id',
  'gender',
  'email',
] as const;

const SAMPLE_ROWS: ReadonlyArray<
  Record<(typeof STUDENT_TEMPLATE_HEADERS)[number], string>
> = [
  {
    name: 'Amira Hossain',
    student_id: 'STU-00123',
    gender: 'female',
    email: 'amira.hossain@example.com',
  },
  {
    name: 'Omar Khalid',
    student_id: 'STU-00124',
    gender: 'male',
    email: 'omar.khalid@example.com',
  },
];

const escapeCsvCell = (value: string): string => {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

export const buildStudentTemplateCsv = (): string => {
  const headerLine = STUDENT_TEMPLATE_HEADERS.join(',');
  const dataLines = SAMPLE_ROWS.map((row) =>
    STUDENT_TEMPLATE_HEADERS.map((key) => escapeCsvCell(row[key])).join(',')
  );
  return [headerLine, ...dataLines].join('\n');
};

export const downloadStudentTemplateCsv = async (
  fileName = 'students-bulk-upload-template.csv'
) => {
  const csv = buildStudentTemplateCsv();
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  await downloadFile(blob, fileName);
};
